export const output = {
  "label": "",
  "children": [
    {
      "name": "QUARTA FASE: RISULTATI FASI A, B e C (SCHEDE DI SUPPORTO)",
      "to": "/app/metodologia/output",
      "exact": true,
      "active": true,
      "icon": "puzzle-piece"
    },
    {
      "name": "INPUT -> Valore aggiunto aziendale (vedi SCHEDE 14 e 16)",
      "exact": true,
      "active": true,
      "to": "/app/questionario/input-conto-economico",
      "icon": "pencil-alt"
    },
    {
      "name": "OUTPUT -> Doppia matrice di materialità (vedi SCHEDE 13 e 15)",
      "to": "/app/questionario/doppia-matrice-materialita",
      "exact": true,
      "active": true,
      "icon": "pencil"
    },
    {
      "name": "OUTPUT -> Valore Aggiunto Riattribuito (VAR) (SCHEDE 14 e 16)",
      "to": "/app/questionario/valore-aggiunto-riattribuito",
      "exact": true,
      "active": true,
      "icon": "pencil"
    },
    {
      "name": "OUTPUT -> Riepilogo dei dati in input (Schema di output coerente con quello utilizzato per l'input - vedi FASE C EFRAG > SCHEDA 12)",
      "to": "/app/questionario/riepilogo",
      "exact": true,
      "active": true,
      "icon": "pencil"
    }
  ]
}


/*
    {
      "name": "Riepilogo attribuzione a VAR misurazione mitigazione rischi di impatti e finanziari con opportunità finanziarie azienda",
      "to": "/app/questionario/riepilogo",
      "exact": true,
      "active": true
    },

*/